import styled from "styled-components";

export const HeaderBox = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  padding: 16px 0;
  background-color: #fff;
  text-align: center;
`;
